import * as Yup from "yup";
import { timePricingSchema } from "./peakOffPeakPricing";

export const packageVoiceSchema = Yup.object().shape({
  title: Yup.string()
    .max(100, "cannot be > 100 characters")
    .required("Title is required"),
  price: Yup.number().when("hasPeakOffPeakPricing", {
    is: false,
    then: Yup.number()
      .required("Price is required")
      .min(0, "Price must be non-negative"),
    otherwise: Yup.number().nullable(),
  }),
  pricingIntervals: timePricingSchema(Yup),
  memberShipType: Yup.string().required("Select membership type"),
  duration: Yup.string().required("Select any duration"),
  session: Yup.string().required("Session is required"),
  days: Yup.number()
    .required("Duration is required")
    .positive("Duration must be positive integer")
    .integer("Duration must be positive integer"),
  sharedBranches: Yup.array().when(["isSharedPackage", "memberShipType"], {
    is: (isSharedPackage, memberShipType) =>
      isSharedPackage && memberShipType === "GYM",
    then: Yup.array().min(1, "Select at least one branch to share with"),
  }),
});
